import { NoData } from "../../assets/assets";
import "./NoDataFound.scss"

const NoDataFound = () => {
    return (
        <div className="nodata">
            <img src={NoData} alt="" />
            <h1>No Data Found</h1>
        </div>
    )
}

export default NoDataFound;